module.exports = __webpack_public_path__ + "img/c_photo_5.ba063fd1.png";